// 导入相应的网络参数校验规则
import { Net_Rules } from "./rules";

/**
 * 该函数会返回一组自动生成的校验规则  在vue文件使得内容不会过于冗长
 * @param {module} 可以根据不同的模块选择不同的参数校验规则 
 * @param {rules} 传入一个数组选择需要校验的参数
 * 
 */
const NET_PARAMS_DEFAULT=['extPanId','channelPage','channelMask','transmitPower','inNetInterval'];


function addRules(module,rules){
    if(!module)
        return new Error("[addRules] module为空");
    if(!rules)
        return new Error("[addRules] 需要校验的字段(rules)为空");
    
    // 根据模块获取当前的规则表
    let ruleTable;
    switch(module){
        case 'net':
            ruleTable=Net_Rules.call(window.vm);
    }

    // 去规则表中查找相应的规则进行导入
    const result={};
    for(let i=0;i<rules.length;i++){
        const ruleName=rules[i];
        result[ruleName]=ruleTable[ruleName];
    }
    return result;
}

//校验网络参数  默认全都传入
export const addNetRules=function(rules=NET_PARAMS_DEFAULT){
    return addRules('net',rules);
}